import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'

import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import JSZip from "jszip";

import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
import Multiselect from 'vue-multiselect'
Vue.component("downloadExcel", JsonExcel);

export default {
	name: 'order',
	components: {
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect,
		Multiselect
	},
	data() {
		return {
			// currentPage: 0,
			mid: '',
			isLoadingforxls: false,
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listOrderReportData: {
				ordercount: 0,
				totalsku: 0,
				totalquantity: 0,
				result: [],
			},
			ponoFlt: "",
			fromDateFlt: '',
			fromDateFltShip: "",
			toDateFltShip: "",
			// perPage: 10,
			// totalPage: 0,
			// pageNo: 0,
			orderStatus: '',
			isLoading: false,
			listClientData: [],
			listWarehouseData: [],
			totalrowsData: [],
			listOrderReportDataCsv: [],

			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,

			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',

			//checkStatus: 0,
			searchchannel: '',


			channellist: [],
			showOrderAllocationRacks: false,
			allocationResultData: [],
			formattedDate: '',
			ordersubtype: '',
			user_type: '',
			userid: '',
			show: false,
			download: true,
			dataFilter2: '',
			dataFilter: '',
			reportname: '',
			reportnameOutside: '',
			reportnameRefurbishedBoxchange: '',
			reportnamereject: '',
			recordLimit: 0,
			limitExeed: false,
			listMerchantData: [],
			merchant: '',
			toDateFlt: '',
			currentDate: '',
			item: {
				value: '',
				text: ''
			},
			listMerchantData1: [{
				value: '',
				text: this.$t('common.merchantPlaceholder')
			}],
			CourierCompany: '',
			listCourierData: [],
			clientproductid: '',
			ProductTags: '',
			reverseAWB: '',
			wmsrtoid: '',
			custreturnid: '',
			OrderId: '',
			clientproductidErr: '',
			ReturnstypeErr: '',
			FromdateErr: '',
			todateErr: '',
			listOrderReportDataArr: [],
			returntypeshow: '',
			listReturnsStatus: [],
			returnstype: 'rto',
			processtype: '',
			listBrandData: [],
			brand: '',
			branditem: {
				value: '',
				text: ''
			},

			options: [{
				value: '',
				text: this.$t('common.selectBrandPlaceHolder')
			}],
			boxchange:0,
			refurbished:0,
			eancode:'',
			activemrpflag:false,
			slastatus : "",
			slaclient:[],
			slaflag:false,
			SubOrderId:'',
			frcawbNo:'',
			frcfromDateFlt:'',
			frcFromdateErr:'',
			frctodateErr:'',
			frctoDateFlt:'',
			frcorderstatus:'',
			frceancode:'',
            listFRCReportData:[],
			reportnamefrc:''
		}
	},
	model: {
		totalqty: 0
	},
	computed: {},
	filters: {

		moment: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY');
		},
		momentDateTime: function (date) {
			if (date != null)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.returnsreceiptreport')
		this.reportnameOutside = this.$t('editedjson.outsideProductreport')
		this.reportnamereject = this.$t('editedjson.returnrejectreport')
		this.reportnamefrc = this.$t('frc.frcreport')

		this.reportnameRefurbishedBoxchange = this.$t('editedjson.refurbishedBoxchangereport')
		this.reportname = this.reportnamereject+ moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportnameOutside = this.reportnameOutside + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportnamereject = this.reportnamereject + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportnameRefurbishedBoxchange = this.reportnameRefurbishedBoxchange + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.reportnamefrc = this.reportnamefrc + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';

		this.pageNo = 0;
		this.orderStatus = 'allocated'
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList()
		this.getcourierList()
		this.getBrandList()
		}

		this.user_type = userdetail.utype;
		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getcourierList();
				this.getBrandList();
				this.getMerchantList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchant = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'))
				break
		}
		this.getRecordLimit();
		//this.calldateFunction();
	}, // End computed
	filters: {
		displayHoursMins(a){
			var hours = Math.trunc(a/60);
			var minutes = a % 60;
			return (hours +":"+ minutes);
		  },
		moment: function (date) {
			if (date)
				return moment(date).format('DD-MM-YYYY HH:mm:ss');
			else {
				return '';
			}
		}
	},
	methods: {
		reset() {
			this.item = {}
			this.branditem = {}
		},
		onSelect(item) {
			this.item = item
			this.merchant = item.value;

		},
		onSelectBrand(item) {
			this.branditem = item
			this.brand = item.text;
		},
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},
		calldateFunction1() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.frctoDateFlt = this.currentDate;
			this.frcfromDateFlt = dt;

		},
		checkrefchange(){
			if(document.getElementById("refurbished").checked == true ){
				document.getElementById("boxchange").checked =false
			}
		}
		,
		checkboxchange(){

			 if(document.getElementById("boxchange").checked ==true){
				document.getElementById("refurbished").checked = false
			}
		},
		getBrandList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({ clientid: this.client });

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getClientAssocitedBrandList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listBrandData = result.data.data;
					this.listBrandData.forEach((e, i) => {
						this.options.push({ value: i + 1, text: e.brandname })
						// { value: 'Vue.js', code: 'vu' },
					})
				}, error => {
					console.error(error)
				})
		},
		getcourierList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({});

			axios({
				method: 'GET',
				'url': apiUrl.api_url + 'courierlistRTO',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listCourierData = result.data.rows;
				}, error => {
					console.error(error)
				})
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.client,
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantListArray = [];
						result.data.forEach(function (item) {
							merchantListArray[item.merchantid] = item.merchantname;
						});
						this.merchantList = merchantListArray;
						this.item = {
							value: '',
							text: ''
						},
							this.listMerchantData1 = [{
								value: '',
								text: this.$t('common.merchantPlaceholder')
							}]
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname

							})
						})

					}
				}, error => {
					console.error(error)
				})
		},


		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype1() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListReportXLS(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype2() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getRejectListReportXLS(3)
			}
		},
		Choosetype3() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOutsideproductReportXLS(3)
			}
		},
		Choosetype4() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getRefurbishedBoxchangeXLS(3)
			}
		},
		Choosetype5() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getPutawayReport(3)
			}
		},
		Choosetype6() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getFRCListXLS()
			}
		},
		Choosetype7() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getFRCRejectListXLS()
			}
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime);
			download(blob, filename, mime);
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			let bstr = atob(base64);
			let n = bstr.length;
			let u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	this.pageNo = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageNo = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageNo = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.listMerchantData = [];
		// 		this.listBrandData = []
		// 		this.returnstype = ''
		// 		this.ordersubtype = ''
		// 		// this.listReturnsStatus=[];
		// 		this.merchant = '';
		// 		this.getMerchantList();
		// 		this.getcourierList();
		// 		this.getActiveMrpFlag();
		// 		if (this.clientid)
		// 			if (this.user_type != 'warehouse_user') {
		// 				this.listWarehouseData = [];
		// 				this.getWarehouseList();
		// 				this.getActiveMrpFlag();
		// 				if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 					this.warehouse = this.warehouseid = '';
		// 				} else {
		// 					this.warehouse = '';
		// 				}
		// 			}
		// 	}
		// 	this.getBrandList();
		// 	this.getMerchantList();
		// 	this.pageNo = this.totalPage = 0;
		// },



		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageNo = this.totalPage = 0;
		// 	if (this.user_type == 'client_user') {
		// 		this.getMerchantList();
		// 	}
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		async getActiveMrpFlag(){
				 var userToken = window.localStorage.getItem('userToken');
				 var myStr = userToken.replace(/"/g, '');
				 this.input = ({
					 "clientid": this.client,
				 });
			 try {

					 axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'checkActivemrpFlg',
							 'data': this.input,
							 headers: {
								 'Authorization': 'Bearer ' + myStr,
							 }
						 })
						 .then(result => {
							 if(result.data.data.data[0].value ==='yes'){
								 this.activemrpflag = true;
							 }else{
								 this.activemrpflag = false;
							 }
						 }, error => {
							 console.error(error);
						 });

				 } catch (err) {
					 throw new Error(err);
				 }
	 },
		getOrderListSearch(csvCheck) {
			this.currentPage = 1;
			this.getOrderListReport(2);
		},
		getOrderRejectListSearch(csvCheck) {
			this.currentPage = 1;
			this.getRejectListReport(2);
		},
		getOustideproductSearch(csvCheck) {
			this.currentPage = 1;
			this.getnotourProductList(2);
		},
		getRefurbishedBoxchangeSearch(csvCheck) {
			this.currentPage = 1;
			this.getRefurbishedBoxchangeList(2);
		},
		getFRCListSearch(csvCheck) {
			this.currentPage = 1;
			this.getFRCList(2);
		},
		getFRCRejectListSearch(){
			this.currentPage = 1;
			this.getFRCRejectList(2);
		},
		getOrderListReport(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};

				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if(this.OrderId == ''){
				this.todateErr = '';
				this.FromdateErr = '';
				if (this.fromDateFlt == '' || this.fromDateFlt == null) {
					this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listPickingReportData = [];
					this.listOrderReportDataArr = [];
					return false
				}
				if (this.toDateFlt == '' || this.toDateFlt == null) {
					this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listPickingReportData = [];
					this.listOrderReportDataArr = [];
					return false
				}
			}
			

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			this.returntypeshow = this.returnstype
			
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;
			if (this.brand == this.$t('common.selectBrandPlaceHolder'))
				this.brand = ''
			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"returnsType": this.returnstype,
				"merchant": this.merchant,
				"fromdate": fromdate,
				"todate": todate,
				"clientproductid": this.clientproductid,
				"returnid": this.wmsrtoid,
				"transporter": this.CourierCompany,
				"awbno": this.reverseAWB,
				"orderid": this.OrderId,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"searchstatus": this.ordersubtype,
				"brand": this.brand,
				"eancode":this.eancode,
				"slastatus" : this.slastatus
			});
			if (csvCheck == 1) {
				var select_api = 'getReturnsReportCSV'
				delete this.input.offset
				delete this.input.limit
				this.input.userid = this.userid
			} else {
				var select_api = 'getReturnsReport'
			}
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.count < this.recordLimit) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFields = {
									'returntype': this.$t('returnReceiptReport.returnsType'),
									'createddatetime': this.$t('returnReceiptReport.returnsDate'),
									'status': this.$t('editedjson.returnsStatus'),
									'returnid': this.$t('returnReceiptReport.wmsReturnId'),
									'cutomerreturnid': this.$t('returnReceiptReport.customerReturnId'),
									'awbno': this.$t('createsr.reverseAWB'),
									'transporter': this.$t('common.courierCompany'),
									'saleschannel': this.$t('common.salesChannel'),
									'orderid': this.$t('srReport.orderId'),
									'orderitemsequence': this.$t('editedjson.orderItemSequence'),
									'clientproductid': this.$t('product.clientProductId'),
									'brand': this.$t('common.brand'),
									'modifiedby': this.$t('common.lastModifiedBy'),
									'modifieddate': this.$t('common.lastModifiedDate'),
									'mrp': this.$t('common.mrp'),
									'activemrp': this.$t('common.activemrp'),
									'merchantname': this.$t('common.merchantName'),
									// 'ProductTags':'ProductTags',
									'expected_quantity': this.$t('returnReceiptReport.expectedQuantity'),
									'received_qty': this.$t('returnReceiptReport.receivedQuantity'),
									'accepted_qty': this.$t('common.acceptedQuantity'),
									'rejected_qty': this.$t('returnReceiptReport.rejectedQuantity'),
									'rackin_accepted_qty': this.$t('returnReceiptReport.acceptedPutAwayQuantity'),
									'rackin_rejected_qty': this.$t('returnReceiptReport.rejectedPutAwayQuantity'),
									'extra_quantity': this.$t('returnReceiptReport.extraQuantity'),
									'excess_quantity': this.$t('returnReceiptReport.excessQuantity'),
									'short_qty': this.$t('returnReceiptReport.shortQuantity'),
									'rackindatetime':this.$t('returnReceiptReport.rackindate'),
									'rackindoneby':this.$t('returnReceiptReport.rackinby'),
									'eancode' : this.$t('returnReceiptReport.eanCode'),
									'grdoneby':this.$t('returnReceiptReport.qcdoneby'),
									'grdonedatetime':this.$t('returnReceiptReport.qcdonedate'),
									'slastatus': this.$t('sla.slastatus'),
									'breachedby': this.$t('sla.breachedby'),
									'sladatetime':this.$t('sla.sladatetime')
									
								};
								if(this.activemrpflag != true){
									skipFilter = ['activemrp','breachdurationinmins'];
                                }
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFields = {
									'returntype': this.$t('returnReceiptReport.returnsType'),
									'createddate': this.$t('returnReceiptReport.returnsDate'),
									'status': this.$t('editedjson.returnsStatus'),
									'returnid': this.$t('returnReceiptReport.wmsReturnId'),
									'clientreturnid': this.$t('returnReceiptReport.customerReturnId'),
									'awbno': this.$t('createsr.reverseAWB'),
									'transporter': this.$t('common.courierCompany'),
									'saleschannel': this.$t('common.salesChannel'),
									'orderid': this.$t('srReport.orderId'),
									//'orderitemsequence': 'Order item sequence',
									'clientproductid': this.$t('product.clientProductId'),
									'brand': this.$t('common.brand'),
									'modifiedby': this.$t('common.lastModifiedBy'),
									'modifieddate': this.$t('common.lastModifiedDate'),
									'mrp': this.$t('common.mrp'),
									'activemrp': this.$t('common.activemrp'),
									'merchantname': this.$t('common.merchantName'),
									// 'ProductTags':'ProductTags',
									'expected_quantity': this.$t('returnReceiptReport.expectedQuantity'),
									'received_qty': this.$t('returnReceiptReport.receivedQuantity'),
									'accepted_qty': this.$t('common.acceptedQuantity'),
									'rejected_qty': this.$t('returnReceiptReport.rejectedQuantity'),
									'rackin_accepted_qty': this.$t('returnReceiptReport.acceptedPutAwayQuantity'),
									'rackin_rejected_qty': this.$t('returnReceiptReport.rejectedPutAwayQuantity'),
									'extra_quantity': this.$t('returnReceiptReport.extraQuantity'),
									'excess_quantity': this.$t('returnReceiptReport.excessQuantity'),
									'short_qty': this.$t('returnReceiptReport.shortQuantity'),
									'rackindatetime':this.$t('returnReceiptReport.rackindate'),
									'rackindoneby':this.$t('returnReceiptReport.rackinby'),
									'eancode' : this.$t('returnReceiptReport.eanCode'),
									'qcdoneby':this.$t('returnReceiptReport.qcdoneby'),
									'qcdate':this.$t('returnReceiptReport.qcdonedate'),
									'slastatus': this.$t('sla.slastatus'),
									'breachedby': this.$t('sla.breachedby'),
									'sladatetime':this.$t('sla.sladatetime'),
									
								};
								if(this.activemrpflag === true){
										skipFilter = ['full_count','breachdurationinmins'];
									}else {
										skipFilter = ['full_count','activemrp','breachdurationinmins'];
									}
							}

							var dateFilter = [];
							if (!this.slaflag) {
								const keysToAdd = ['slastatus','breachedby','sladatetime'];
								keysToAdd.forEach(key => {
								  if (!skipFilter.includes(key)) {
									skipFilter.push(key);
								  }
								});
							}

							this.listOrderReportDataCsv = result.data.data.filter(function (el) { return delete el.orderitemsequence });

							csvHelper.data.jsonToCSV(this.$t('editedjson.returnsreceiptreport'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportDataArr = result.data.data;
						this.totalRows = Number(result.data.count)
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getOrderListReportXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.client == undefined) {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};

				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == undefined) {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if(this.OrderId == ''){
				this.todateErr = '';
				this.FromdateErr = '';
				if (this.fromDateFlt == '' || this.fromDateFlt == null) {
					this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listPickingReportData = [];
					this.listOrderReportDataArr = [];
					return false
				}
				if (this.toDateFlt == '' || this.toDateFlt == null) {
					this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
					this.pageNo = this.totalPage = 0;
					this.totalRows = 0;
					this.listPickingReportData = [];
					this.listOrderReportDataArr = [];
					return false
				}
			}
			// if (this.fromDateFlt == '' || this.fromDateFlt == null) {
			// 	this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
			// 	return false
			// }
			// if (this.toDateFlt == '' || this.toDateFlt == null) {
			// 	this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
			// 	return false
			// }
			// if (action == 1)
			//   this.pageNo = this.totalPage = 0;
			var fromdate = '';
			var todate = '';
			var value = '';
			var str = ''
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}

			if (this.fromDateFltShip != null && this.fromDateFltShip != "") {
				fromdateship = this.dateFormat(this.fromDateFltShip) + " 00:00:00";
			}
			if (this.toDateFltShip != null && this.toDateFltShip != "") {
				todateship = this.dateFormat(this.toDateFltShip) + " 23:59:59";
			}

			this.isLoading = true;
			if (this.brand == this.$t('common.selectBrandPlaceHolder'))
				this.brand = ''
			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"returnsType": this.returnstype,
				"merchant": this.merchant,
				"fromdate": fromdate,
				"todate": todate,
				"userid": this.userid,
				"clientproductid": this.clientproductid,
				"returnid": this.wmsrtoid,
				"transporter": this.CourierCompany,
				"awbno": this.reverseAWB,
				"orderid": this.OrderId,
				"searchstatus": this.ordersubtype,
				"brand": this.brand,
				"eancode":this.eancode,
				"slastatus" : this.slastatus
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getReturnsReportCSV',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsDate')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('editedjson.returnsStatus')]= 'status';
								this.csvFieldsForXls[this.$t('returnReceiptReport.wmsReturnId')]= 'returnid';
								this.csvFieldsForXls[this.$t('returnReceiptReport.customerReturnId')]= 'cutomerreturnid';
								this.csvFieldsForXls[this.$t('createsr.reverseAWB')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'transporter';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('product.clientProductId')]= 'clientproductid';
								this.csvFieldsForXls[this.$t('common.brand')]= 'brand';
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]= 'modifiedby';
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]= 'modifieddate';
								this.csvFieldsForXls[this.$t('common.mrp')]= 'mrp';
								if(this.activemrpflag === true){
								 this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							  }
								this.csvFieldsForXls[this.$t('common.merchantName')]= 'merchantname';
								this.csvFieldsForXls[this.$t('returnReceiptReport.expectedQuantity')]= 'expected_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.receivedQuantity')]= 'received_qty';
								this.csvFieldsForXls[this.$t('common.acceptedQuantity')]= 'accepted_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedQuantity')]= 'rejected_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.acceptedPutAwayQuantity')]= 'rackin_accepted_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedPutAwayQuantity')]= 'rackin_rejected_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.extraQuantity')]= 'extra_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.excessQuantity')]= 'excess_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.shortQuantity')]= 'short_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rackindate')]='rackindatetime';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rackinby')]='rackindoneby';
								this.csvFieldsForXls[this.$t('returnReceiptReport.qcdoneby')]='grdoneby';
								this.csvFieldsForXls[this.$t('returnReceiptReport.qcdonedate')]='grdonedatetime';
								this.csvFieldsForXls[this.$t('sla.slastatus')]='slastatus';
								this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby';
								this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime';
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsDate')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('editedjson.returnsStatus')]= 'status';
								this.csvFieldsForXls[this.$t('returnReceiptReport.wmsReturnId')]= 'returnid';
								this.csvFieldsForXls[this.$t('returnReceiptReport.customerReturnId')]= 'cutomerreturnid';
								this.csvFieldsForXls[this.$t('createsr.reverseAWB')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'transporter';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('product.clientProductId')]= 'clientproductid';
								this.csvFieldsForXls[this.$t('common.brand')]= 'brand';
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]= 'modifiedby';
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]= 'modifieddate';
								this.csvFieldsForXls[this.$t('common.mrp')]= 'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							 }
								this.csvFieldsForXls[this.$t('common.merchantName')]= 'merchantname';
								this.csvFieldsForXls[this.$t('returnReceiptReport.expectedQuantity')]= 'expected_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.receivedQuantity')]= 'received_qty';
								this.csvFieldsForXls[this.$t('common.acceptedQuantity')]= 'accepted_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedQuantity')]= 'rejected_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.acceptedPutAwayQuantity')]= 'rackin_accepted_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedPutAwayQuantity')]= 'rackin_rejected_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.extraQuantity')]= 'extra_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.excessQuantity')]= 'excess_quantity';
								this.csvFieldsForXls[this.$t('returnReceiptReport.shortQuantity')]= 'short_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rackindate')]='rackindatetime';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rackinby')]='rackindoneby';
								this.csvFieldsForXls[this.$t('returnReceiptReport.qcdoneby')]='qcdoneby';
								this.csvFieldsForXls[this.$t('returnReceiptReport.qcdonedate')]='qcdate';
								this.csvFieldsForXls[this.$t('sla.slastatus')]='slastatus';
								this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby';
								this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime';
								skipFilter = ['full_count'];
							}

							this.listReportDataforxls = result.data.data;
							const keysToRemove = [this.$t('sla.slastatus'),this.$t('sla.breachedby'),this.$t('sla.sladatetime')];
							if (!this.slaflag) {
							  keysToRemove.forEach(key => {
								if (this.csvFieldsForXls.hasOwnProperty(key)) {
								  delete this.csvFieldsForXls[key];
								}
							  });
							}
							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}


					}


				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getRejectListReport(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			this.download = true;
			this.show = false;
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			this.returntypeshow = this.returnstype
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}
			this.isLoading = true;
			if (this.brand == this.$t('common.selectBrandPlaceHolder'))
				this.brand = ''
			this.input = ({

				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"returnsType": this.returnstype,
				"merchant": this.merchant,
				"fromdate": fromdate,
				"todate": todate,
				"returnid": this.wmsrtoid,
				"clientproductid": this.clientproductid,
				"transporter": this.CourierCompany,
				"awbno": this.reverseAWB,
				"orderid": this.OrderId,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"searchstatus": this.ordersubtype,
				"brand": this.brand
			});
			if (csvCheck == 1) {
				var select_api = 'getRejectProductsReportCsv'
				delete this.input.offset
				delete this.input.limit
				this.input.userid = this.userid
			} else {
				var select_api = 'getRejectProductsReport'
			}
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.count < this.recordLimit) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFields = {
									'id': this.$t('common.id'),
									'returntype': this.$t('returnReceiptReport.returnsType'),
									'createddate': this.$t('common.createdDateTime'),
									'status': this.$t('common.status'),
									'returnid': this.$t('editedjson.returnid'),
									'awbno': this.$t('common.awbNo'),
									'transporter': this.$t('common.courierCompany'),
									'saleschannel': this.$t('common.salesChannel'),
									'orderid': this.$t('srReport.orderId'),
									'clientproductid': this.$t('product.clientProductId'),
									'brand': this.$t('common.brand'),
									'modifiedby': this.$t('common.lastModifiedBy'),
									'modifieddate': this.$t('common.lastModifiedDate'),
									'mrp': this.$t('common.mrp'),
									'activemrp': this.$t('common.activemrp'),
									'merchantname': this.$t('common.merchantName'),
									'rejected_qty': this.$t('returnReceiptReport.rejectedQuantity'),
									'rejectreason': this.$t('common.rejectReason'),
									'imageslink': this.$t('editedjson.imagesLink')
								};
								if(this.activemrpflag === false){
 									skipFilter = ['activemrp'];
                 }
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFields = {
									'id': this.$t('common.id'),
									'returntype': this.$t('returnReceiptReport.returnsType'),
									'createddate': this.$t('common.createdDate'),
									'status': this.$t('common.status'),
									'srid': this.$t('editedjson.returnid'),
									'awbno': this.$t('common.awbNo'),
									'transporter': this.$t('common.courierCompany'),
									'saleschannel': this.$t('common.salesChannel'),
									'orderid': this.$t('srReport.orderId'),
									'clientproductid': this.$t('product.clientProductId'),
									'brand': this.$t('common.brand'),
									'modifiedby': this.$t('common.lastModifiedBy'),
									'modifieddate': this.$t('common.lastModifiedDate'),
									'mrp': this.$t('common.mrp'),
									'activemrp' : this.$t('common.activemrp'),
									'merchantname': this.$t('common.merchantName'),
									'rejected_qty': this.$t('returnReceiptReport.rejectedQuantity'),
									'rejectreason': this.$t('common.rejectReason'),
									'imageslink': this.$t('editedjson.imagesLink')
								};
								if(this.activemrpflag === true){
									 skipFilter = ['full_count'];
								 }else {
									 skipFilter = ['full_count','activemrp'];
								 }
							}

							var dateFilter = [];
							this.listOrderReportDataCsv = result.data.data;

							csvHelper.data.jsonToCSV(this.$t('editedjson.returnrejectreport'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportDataArr = result.data.data;
						this.totalRows = Number(result.data.count);
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		downloadImageAsZip(data, nopornot) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				rto_rvp: data.returntype.toLowerCase(),
				id: data.id,
				clientid: this.client,
				nopornot: nopornot
			});
			this.isLoading = true

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'downloadimgzip',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then((result) => {
				if (result.data.status == false) {
					this.$alertify.error(result.data.msg)
				} else {
					function _arrayBufferToBase64(buffer) {
						var binary = '';
						var bytes = new Uint8Array(buffer);
						var len = bytes.byteLength;
						for (var i = 0; i < len; i++) {
							binary += String.fromCharCode(bytes[i]);
						}
						return window.btoa(binary);
					}
					var zip = new JSZip();
					var img = new Image();
					var img = zip.folder("images");
					if (this.returntypeshow == 'rvp') {
						var flg = data.srid
					} else {
						var flg = data.rtoid
					}

					result.data.data.forEach((e, i) => {
						let base64String = _arrayBufferToBase64(e.data)
						if (result.data.extension[i] == '') { result.data.extension[i] = '.png' }
						img.file("Image" + i + '.' + result.data.extension[i], base64String, { base64: true });

					})

					var saveAs = require('file-saver');

					let name = data.returntype.toLowerCase() + '_' + flg + '_' + ".zip"
					zip.generateAsync({ type: "blob" }).then(function (content) {
						saveAs(content, name);
					});
					this.isLoading = false
				}
			})
		},
		getRejectListReportXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.client == undefined) {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == undefined) {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr =  this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}
			// if (action == 1)
			//   this.pageNo = this.totalPage = 0;
			var fromdate = '';
			var todate = '';
			var value = ''
			var str = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};

			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}

			this.isLoading = true;
			if (this.brand == this.$t('common.selectBrandPlaceHolder'))
				this.brand = ''
			this.input = ({

				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"returnsType": this.returnstype,
				"clientproductid": this.clientproductid,
				"merchant": this.merchant,
				"fromdate": fromdate,
				"todate": todate,
				"returnid": this.wmsrtoid,
				"transporter": this.CourierCompany,
				"awbno": this.reverseAWB,
				"orderid": this.OrderId,
				"searchstatus": this.ordersubtype,
				"brand": this.brand
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRejectProductsReportCsv',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFieldsForXls[this.$t('common.id')]= 'id';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('common.createdDateTime')]= 'createddate';
								this.csvFieldsForXls[this.$t('common.status')]= 'status';
								this.csvFieldsForXls[this.$t('editedjson.returnid')]= 'returnid';
								this.csvFieldsForXls[this.$t('common.awbNo')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'transporter';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('product.clientProductId')]= 'clientproductid';
								this.csvFieldsForXls[this.$t('common.brand')]= 'brand';
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]= 'modifiedby';
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]= 'modifieddate';
								this.csvFieldsForXls[this.$t('common.mrp')]= 'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')]= 'activemrp';
								}
								this.csvFieldsForXls[this.$t('common.merchantName')]= 'merchantname';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedQuantity')]= 'rejected_qty';
								this.csvFieldsForXls[this.$t('editedjson.imagesLink')]= 'imageslink';

							}
							if (this.returntypeshow == 'rvp') {
								this.csvFieldsForXls[this.$t('common.id')]= 'id';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('common.createdDateTime')]= 'createddate';
								this.csvFieldsForXls[this.$t('common.status')]= 'status';
								this.csvFieldsForXls[this.$t('editedjson.returnid')]= 'srid';
								this.csvFieldsForXls[this.$t('common.awbNo')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'transporter';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('product.clientProductId')]= 'clientproductid';
								this.csvFieldsForXls[this.$t('common.brand')]= 'brand';
								this.csvFieldsForXls[this.$t('common.lastModifiedBy')]= 'modifiedby';
								this.csvFieldsForXls[this.$t('common.lastModifiedDate')]= 'modifieddate';
								this.csvFieldsForXls[this.$t('common.mrp')]= 'mrp';
								if(this.activemrpflag === true){
									this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp'
								}
								this.csvFieldsForXls[this.$t('common.merchantName')]= 'merchantname';
								this.csvFieldsForXls[this.$t('returnReceiptReport.rejectedQuantity')]= 'rejected_qty';
								this.csvFieldsForXls[this.$t('editedjson.imagesLink')]= 'imageslink';
								skipFilter = ['full_count'];
							}

							this.listReportDataforxls = result.data.data;
							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}


					}


				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getnotourProductList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			this.returntypeshow = this.returnstype
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt);
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt);
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({

				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"processstatus": this.returnstype,
				"fromdate": fromdate,
				"todate": todate,
				"userid": this.userid,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"searchstatus": this.ordersubtype,
				"csvData": csvCheck,

			});
			if (csvCheck == 1) {
				var select_api = 'getNotOurProductsreturns'
				delete this.input.offset
				delete this.input.limit
			} else {
				var select_api = 'getNotOurProductsreturns'
			}
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.count < this.recordLimit) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFields = {
                                    'id': this.$t('common.id'),
                                    'returntype': this.$t('returnReceiptReport.returnsType'),
                                    'returnstatus': this.$t('rejectlistrto.returnStatus'),
                                    'createddatetime': this.$t('common.createdDateTime'),
                                    'status': this.$t('common.status'),
                                    'rtoid': this.$t('rejectlistrto.rtoId'),
                                    'awbno': this.$t('rejectlistrto.awbNo'),
                                    'couriercompany': this.$t('common.courierCompany'),
                                    'saleschannel': this.$t('common.salesChannel'),
                                    'orderid': this.$t('common.orderID'),
                                    'productid': this.$t('editedjson.outsideProductid'),
                                    'description': this.$t('common.description'),
                                    // 'mrp':'Mrp',
                                    // 'ProductTags':'ProductTags',
                                    'receivedqty': this.$t('shipment.receivedQty'),
                                    'imageslink': this.$t('editedjson.imagesLink')
                                };
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFields = {
                                    'id': this.$t('common.id'),
                                    'returntype': this.$t('returnReceiptReport.returnsType'),
                                    'returnstatus':this.$t('rejectlistrto.returnStatus'),
                                    'createddatetime': this.$t('common.createdDateTime'),
                                    'status': this.$t('common.status'),
                                    'srid': this.$t('rejectlistrto.rvpId'),
                                    'awbno': this.$t('rejectlistrto.awbNo'),
                                    'couriercompany':  this.$t('common.courierCompany'),
                                    'saleschannel': this.$t('common.salesChannel'),
                                    'orderid': this.$t('common.orderID'),
                                    'productid': this.$t('editedjson.outsideProductid'),
                                    'description': this.$t('common.description'),
                                    // 'mrp':'Mrp',
                                    // 'ProductTags':'ProductTags',
                                    'receivedqty': this.$t('shipment.receivedQty'),
                                    'imageslink': this.$t('editedjson.imagesLink')
                                };
								skipFilter = [];
							}

							var dateFilter = [];

							this.listOrderReportDataCsv = result.data.data.filter(function (el) { return delete el.orderitemsequence });

							csvHelper.data.jsonToCSV(this.$t('editedjson.outsideProductreport'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportDataArr = result.data.data;
						this.totalRows = Number(result.data.count);
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getOutsideproductReportXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.client == undefined) {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == undefined) {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;

				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var value = '';
			var str = ''

			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt);
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt);
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({

				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"processstatus": this.returnstype,
				"fromdate": fromdate,
				"todate": todate,
				"userid": this.userid,

				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"searchstatus": this.ordersubtype,
				"csvData": csvCheck,

			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getNotOurProductsreturns',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFieldsForXls[this.$t('common.id')]= 'id';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('common.createdDateTime')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('rejectlistrto.returnStatus')]= 'returnstatus';
								this.csvFieldsForXls[this.$t('shipment.rtoId')]= 'rtoid';
								this.csvFieldsForXls[this.$t('common.awbNo')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'couriercompany';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('editedjson.outsideProductid')]= 'productid';
								this.csvFieldsForXls[this.$t('shipment.receivedQty')]= 'receivedqty';
								this.csvFieldsForXls[this.$t('common.description')]= 'description';
								this.csvFieldsForXls[this.$t('editedjson.imagesLink')]= 'imageslink';
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFieldsForXls[this.$t('common.id')]= 'id';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returntype';
								this.csvFieldsForXls[this.$t('common.createdDateTime')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('rejectlistrto.returnStatus')]= 'returnstatus';
								this.csvFieldsForXls[this.$t('rejectlistrto.rvpID')]= 'srid';
								this.csvFieldsForXls[this.$t('common.awbNo')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.courierCompany')]= 'couriercompany';
								this.csvFieldsForXls[this.$t('common.salesChannel')]= 'saleschannel';
								this.csvFieldsForXls[this.$t('srReport.orderId')]= 'orderid';
								this.csvFieldsForXls[this.$t('editedjson.outsideProductid')]= 'productid';
								this.csvFieldsForXls[this.$t('shipment.receivedQty')]= 'receivedqty';
								this.csvFieldsForXls[this.$t('common.description')]= 'description';
								this.csvFieldsForXls[this.$t('editedjson.imagesLink')]= 'imageslink';
								skipFilter = [''];
							}
							this.listReportDataforxls = result.data.data;

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getRefurbishedBoxchangeList(csvCheck = 0){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			this.returntypeshow = this.returnstype
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt);
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt);
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;
			this.refurbished = document.getElementById("refurbished").checked ? 1 : 0
			this.boxchange = document.getElementById("boxchange").checked ? 1 : 0

			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"fromdate": fromdate,
				"todate": todate,
				"processstatus": this.returnstype,
				"awbno":this.reverseAWB,
				"userid": this.userid,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"csvData": csvCheck,
				"refurbished":this.refurbished,
				"boxchange":this.boxchange
			});
			if (csvCheck == 1) {
				var select_api = 'getRefurbishedBoxchangeReport'
				delete this.input.offset
				delete this.input.limit
			} else {
				var select_api = 'getRefurbishedBoxchangeReport'
			}
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.count < this.recordLimit) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFields = {
									'returnstype': this.$t('returnReceiptReport.returnsType'),
									'createddatetime': this.$t('returnReceiptReport.returnsCreatedDate'),
									'rtoid': this.$t('returnReceiptReport.wmsReturnsId'),
									'awbno': this.$t('createsr.reverseAWB'),
							   		'orderid': this.$t('common.orderID'),
									'productid': this.$t('common.productId'),
									'refurbishedqty':this.$t('returnReceiptReport.refurbishedQuantity'),
									'boxchangeqty':this.$t('returnReceiptReport.boxChangeQuantity'),
									'producttype': this.$t('common.productType')
								};

							}
							if (this.returntypeshow == 'rvp') {
								this.csvFields = {
									'returnstype': this.$t('returnReceiptReport.returnsType'),
									'createddatetime': this.$t('returnReceiptReport.returnsCreatedDate'),
									'rtoid': this.$t('returnReceiptReport.wmsReturnsId'),
									'awbno': this.$t('createsr.reverseAWB'),
							   		'orderid': this.$t('common.orderID'),
									'productid': this.$t('common.productId'),
									'refurbishedqty':this.$t('returnReceiptReport.refurbishedQuantity'),
									'boxchangeqty':this.$t('returnReceiptReport.boxChangeQuantity'),
									'producttype': this.$t('common.productType')
								};

								skipFilter = [];
							}

							var dateFilter = [];

							this.listOrderReportDataCsv = result.data.data.filter(function (el) { return delete el.orderitemsequence });

							csvHelper.data.jsonToCSV(this.$t('editedjson.refurbishedBoxchangereport'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.listOrderReportDataArr = result.data.data;
						this.totalRows = Number(result.data.count);
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getRefurbishedBoxchangeXLS(csvCheck = 0) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.client == undefined) {
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == undefined) {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;

				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var value = '';
			var str = ''

			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt);
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt);
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"fromdate": fromdate,
				"todate": todate,
				"processstatus": this.returnstype,
				"userid": this.userid,
				"awbno":this.reverseAWB,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"csvData": csvCheck,
				"refurbished":this.refurbished,
				"boxchange":this.boxchange
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRefurbishedBoxchangeReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (csvCheck == 3) {
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							if (this.returntypeshow == 'rto') {
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returnstype';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsCreatedDate')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('returnReceiptReport.wmsReturnsId')]= 'rtoid';
								this.csvFieldsForXls[this.$t('createsr.reverseAWB')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.orderID')]= 'orderid';
								this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
								this.csvFieldsForXls[this.$t('returnReceiptReport.refurbishedQuantity')]= 'refurbishedqty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.boxChangeQuantity')]= 'boxchangeqty';
								this.csvFieldsForXls[this.$t('common.productType')]= 'producttype';
							}
							if (this.returntypeshow == 'rvp') {
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')]= 'returnstype';
								this.csvFieldsForXls[this.$t('returnReceiptReport.returnsCreatedDate')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('common.status')]= 'status';
								this.csvFieldsForXls[this.$t('returnReceiptReport.wmsReturnsId')]= 'srid';
								this.csvFieldsForXls[this.$t('createsr.reverseAWB')]= 'awbno';
								this.csvFieldsForXls[this.$t('common.orderID')]= 'orderid';
								this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
								this.csvFieldsForXls[this.$t('returnReceiptReport.refurbishedQuantity')]= 'refurbishedqty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.boxChangeQuantity')]= 'boxchangeqty';
								this.csvFieldsForXls[this.$t('common.productType')]= 'producttype';
								skipFilter = [];
							}
							this.listReportDataforxls = result.data.data;
							//console.log(result.data.data);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					}
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getPutawayReport(csvCheck = 0) {
			let userToken = window.localStorage.getItem('userToken');
			let myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrderReportData = {
					ordercount: 0,
					totalsku: 0,
					totalquantity: 0,
					result: [],
				};
				return false;
			}
			if (this.returnstype == '') {
				this.ReturnstypeErr = this.$t('returnReceiptReport.returnTypeError');
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}
			let value = '', str = '', fromdate = '', todate = '';
			let dataFilter = {};
			this.returntypeshow = this.returnstype
			if (this.fromDateFlt != null && this.fromDateFlt != "") {
				fromdate = this.dateFormat(this.fromDateFlt) + " 00:00:00";
			}
			if (this.toDateFlt != null && this.toDateFlt != "") {
				todate = this.dateFormat(this.toDateFlt) + " 23:59:59";
			}
			let months;
			let fromDate = new Date(this.fromDateFlt);
			let ToDate = new Date(this.toDateFlt);

			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.fromDateFlt != '' && this.fromDateFlt != null && this.toDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listPickingReportData = [];
				return false;
			}

			this.isLoading = true;
			if (this.brand == this.$t('common.selectBrandPlaceHolder'))
				this.brand = ''
			this.input = ({
				"clientid": this.client,
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"returnsType": this.returnstype,
				"merchant": this.merchant,
				"fromdate": fromdate,
				"todate": todate,
				"clientproductid": this.clientproductid,
				"returnid": this.wmsrtoid,
				"transporter": this.CourierCompany,
				"awbno": this.reverseAWB,
				"orderid": this.OrderId,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
				"userid": this.userid,
				"brand": this.brand,
				"csv_xlsFlag": csvCheck,

			});

			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData', 'csv_xlsFlag'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getReturnsPutawayReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {

					result.data.count = result.data.status ? Number(result.data.count) : 0
					console.log(result, "result", csvCheck);
					if (csvCheck == 1 || csvCheck == 3) {
						if (result.data.count < this.recordLimit) {
							this.show = true;
							this.download = false;
							this.listOrderReportDataCsv = [];
							let skipFilter = [];

							if (csvCheck == 1) {
								this.csvFields = {
									'returnstype': this.$t('returnReceiptReport.returnsType'),
                                    'returnsid': this.$t('returnReceiptReport.wmsReturnId'),
                                    'awbno': this.$t('createsr.reverseAWB'),
                                    'transporter': this.$t('common.courierCompany'),
                                    'saleschannel': this.$t('common.salesChannel'),
                                    'orderid': this.$t('common.orderID'),
                                    'clientproductid': this.$t('common.clientProductId'),
                                    'eancode': this.$t('common.eanCode'),
                                    'brand': this.$t('common.brand'),
                                    'mrp': this.$t('common.mrp'),
																		'activemrp': this.$t('common.activemrp'),
                                    'rackinqty': this.$t('editedjson.putawayQuantity'),
                                    'rackid': this.$t('returnReceiptReport.putawayRackid'),
                                    'merchantname': this.$t('common.merchantName'),
                                    'racktype': this.$t('returnReceiptReport.putawayRackType'),
                                    'rackindate': this.$t('returnReceiptReport.putawayDateAndTime'),
                                    'rackinby': this.$t('returnReceiptReport.putawayBy'),
								};
								let dateFilter = [];
								if(this.activemrpflag === true){
									skipFilter = ['full_count'];
								}else {
									skipFilter = ['full_count','activemrp'];
								}
								this.listOrderReportDataCsv = result.data.data
								csvHelper.data.jsonToCSV(this.$t('editedjson.returnputawayreport'), this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);							}
							else if (csvCheck == 3) {
								this.reportnamereject = this.$t('editedjson.returnputawayreport') + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
								this.listReportDataforxls = result.data.data;
								this.csvFieldsForXls =[];
                                this.csvFieldsForXls[this.$t('returnReceiptReport.returnsType')] = 'returnstype';
                                this.csvFieldsForXls[this.$t('returnReceiptReport.wmsReturnId')] = 'returnsid';
                                this.csvFieldsForXls[this.$t('createsr.reverseAWB')] = 'awbno';
                                this.csvFieldsForXls[this.$t('common.courierCompany')] = 'transporter';
                                this.csvFieldsForXls[this.$t('common.salesChannel')] = 'saleschannel';
                                this.csvFieldsForXls[this.$t('common.orderID')] = 'orderid';
                                this.csvFieldsForXls[this.$t('common.clientProductId')] = 'clientproductid';
                                this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode';
                                this.csvFieldsForXls[this.$t('common.brand')] = 'brand';
                                this.csvFieldsForXls[this.$t('common.mrp')] = 'mrp';
																if(this.activemrpflag){
																	this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
																}
                                this.csvFieldsForXls[this.$t('editedjson.putawayQuantity')] = 'rackinqty';
                                this.csvFieldsForXls[this.$t('returnReceiptReport.putawayRackid')] = 'rackid';
                                this.csvFieldsForXls[this.$t('common.merchantName')] = 'merchantname';
                                this.csvFieldsForXls[this.$t('returnReceiptReport.putawayRackType')] = 'racktype';
                                this.csvFieldsForXls[this.$t('returnReceiptReport.putawayDateAndTime')] = 'rackindate';
                                this.csvFieldsForXls[this.$t('returnReceiptReport.putawayBy')] = 'rackinby';

							}
						} else {
							this.limitExeed = true
							this.$alertify.success(this.$t('common.reportSizeError'));
						}
					} else {
						this.limitExeed = false;
						this.show = false;
						this.download = true;
						this.listOrderReportDataArr = result.data.data;
						this.totalRows = Number(result.data.count)
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		onPageChange(page) {

			this.currentPage = page;
			if (this.orderStatus == 'Returnsreciept') {
				this.getOrderListReport()
			}
			else if (this.orderStatus == 'reject') {
				this.getRejectListReport()
			}
			else if (this.orderStatus == 'putaway') {
				this.getPutawayReport(2)
			} else if (this.orderStatus == 'Outsideproduct') {
				this.getnotourProductList(2)
			} else if (this.orderStatus == 'FRC') {
				this.getFRCList(2)
			}else if (this.orderStatus == 'FRCReject') {
				this.getFRCRejectList(2)
			}
			else{
				this.getRefurbishedBoxchangeList(2)
			}
		},
		loadOrderReport(status) {
			this.listOrderReportDataArr = []
			this.ClientErr = ''
			this.calldateFunction();
			this.calldateFunction1();
			this.item = {
				value: '',
				text: ''
			};
			this.branditem = {
				value: '',
				text: ''
			};
			// this.options = [{
			// 	value: '',
			// 	text: this.$t('common.selectBrandPlaceHolder')
			// }];
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.merchantPlaceholder')
			// }];
			this.totalRows = 0;
			this.orderStatus = status;
			this.pageNo = this.totalPage = 0;
			this.dataFilter2 = '';
			this.ponoFlt = '';
			this.searchchannel = '';
			this.custreturnid = '',
				this.wmsrtoid = '';
			this.offset = 0;
			this.currentPage = 1;
			this.reverseAWB = ''
			this.CourierCompany = ''
			this.OrderId = ''
			this.clientproductid = ''
			this.ProductTags = ''
			this.ReturnstypeErr = '',
				this.FromdateErr = '',
				this.todateErr = ''
			this.WarehouseErr = ''
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.returnstype = '';
			this.ordersubtype = '';
			if (this.user_type == 'warehouse_user')
				this.clientewa = '';
			else if (this.user_type == 'client_user')
				this.warehousefwe = '';
			else {
				this.cliented = '';
				this.warehousead = '';
			}
			this.SubOrderId = '';
			this.frcawbNo = '';
			this.frcorderstatus= '';
			this.frceancode = '';
		},
		resetOffset(){
			this.currentPage = 1;
		},

		resetOrderSerach() {
			this.item = {
				value: '',
				text: ''
			};
			this.branditem = {
				value: '',
				text: ''
			};
			// this.options = [{
			// 	value: '',
			// 	text: this.$t('common.selectBrandPlaceHolder')
			// }];
			// this.listMerchantData1 = [{
			// 	value: '',
			// 	text: this.$t('common.merchantPlaceholder')
			// }];
			this.slastatus=''
			this.returnstype = ''
			this.ClientErr = ''
			this.WarehouseErr = '',
				this.ReturnstypeErr = '',
				this.FromdateErr = ''
			this.todateErr = '',
				this.returnsType = ''
			this.show = false;
			this.download = true;
			this.ordersubtype = ''
			this.totalRows = 0;
			this.pageNo = this.totalPage = 0;
			this.CourierCompany = ''
			this.ProductTags = ''
			this.ReturnstypeErr = '',
				this.FromdateErr = '',
				this.todateErr = ''
			this.listOrderReportDataArr = []
			if (this.OrderId != '' && this.OrderId != null) {
				document.getElementById("OrderId").value = "";
			}
			if (this.clientproductid != '' && this.clientproductid != null) {
				document.getElementById("clientproductid").value = "";
			}
			if (this.custreturnid != '' && this.custreturnid != null) {
				document.getElementById("custreturnid").value = "";
			}
			if (this.wmsrtoid != '' && this.wmsrtoid != null) {
				document.getElementById("wmsrtoid").value = "";
			}

			if (this.reverseAWB != '' && this.reverseAWB != null) {
				document.getElementById("reverseAWB").value = "";
			}
			this.OrderId = '';
			this.wmsrtoid = '';
			this.clientproductid = '';
			this.custreturnid = '';
			this.reverseAWB = ''
			this.searchchannel = '';
			this.fromDateFlt = '';
			this.toDateFlt = '';
			this.fromDateFltShip = '';
			this.toDateFltShip = '';
			this.listMerchantData = [];
			this.listBrandData = []
			this.merchant = ''
			this.brand = ''
			this.frcfromDateFlt = '';
			this.frctoDateFlt = '';
			if (this.SubOrderId != '' && this.SubOrderId != null) {
			  document.getElementById("SubOrderId").value = "";
			}
			if (this.frcawbNo != '' && this.frcawbNo != null) {
				document.getElementById("frcawbNo").value = "";
			}
			if (this.frceancode != '' && this.frceancode != null) {
				document.getElementById("frceancode").value = "";
			}
			//this.eancode = ''
			if (this.eancode != '' && this.eancode != null) {
			  document.getElementById("eancode").value = "";
		   }
			if (this.user_type == 'warehouse_user')
				this.clientiy = '';
			else if (this.user_type == 'client_user')
				this.warehouserw = '';
			else {
				this.clienteer = '';
				this.warehouseweq = '';
			}
		},

		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then(() => { }).catch(() => { });
		},
		getFRCList(csvCheck = 0){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frctodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid":  Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"fromdate": fromdate,
				"todate": todate,
				"suborderid":this.SubOrderId,
				"returnstatus":this.frcorderstatus,
				"awbno":this.frcawbNo,
				"eancode":this.frceancode,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
			});
			
				var select_api = 'getFRCReturnsReport'
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
						this.listFRCReportData = result.data.data;
						this.totalRows = Number(result.data.count);
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getFRCListCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frcTodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			var skipFilter = [];
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid": Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"fromdate": fromdate,
				"todate": todate,
				"suborderid":this.SubOrderId,
				"returnstatus":this.frcorderstatus,
				"awbno":this.frcawbNo,
				"eancode":this.frceancode,
				"userid":this.userid
			});
			
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + "getFRCReturnsReportCSV",
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.csvFields = {
									'createddatetime': this.$t('frc.returnsdate'),
                                    'status': this.$t('frc.returnstatus'),
                                    'awbno': this.$t('frc.awbnum'),
                                    'couriercompany': this.$t('frc.couriercomp'),
                                    'suborderid': this.$t('frc.suborderid'),
                                    'clientproductid': this.$t('frc.clientproductid'),
									'productid': this.$t('common.productId'),
                                    'eancode': this.$t('frc.eanCode'),
                                    'mrp': this.$t('frc.mrp'),
                                    'received_qty': this.$t('frc.receivedqty'),
						            'expected_qty': this.$t('returnReceiptReport.expectedQuantity'),
                                    'accepted_qty': this.$t('frc.acceptedqty'),
                                    'rejected_qty': this.$t('frc.rejectedqty'),
								    'rejected_qty': this.$t('frc.rejectedqty'),
									'short_qty': this.$t('returnReceiptReport.shortQuantity'),
									'extra_qty': this.$t('returnReceiptReport.extraQuantity'),
									'excess_qty': this.$t('returnReceiptReport.excessQuantity'),
                                    'accepted_putaway_qty': this.$t('frc.rackinaccqty'),
                                    'rejected_putaway_qty': this.$t('frc.rackinrejqty'),
									'createdby':this.$t('frc.createdby'),
									'closedby':this.$t('frc.closedby'),
									'closeddatetime':this.$t('frc.closeddatetime')
								};
						let dateFilter = [];
						skipFilter = ['full_count'];
						this.listFRCReportDataCsv = result.data.data
						csvHelper.data.jsonToCSV(this.$t('frc.frcreport'), this.listFRCReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);			
						
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getFRCListXLS() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frcTodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid":  Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"fromdate": fromdate,
				"todate": todate,
				"suborderid":this.SubOrderId,
				"returnstatus":this.frcorderstatus,
				"awbno":this.frcawbNo,
				"eancode":this.frceancode,
				"userid":this.userid
			});
			
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + "getFRCReturnsReportCSV",
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
								this.csvFieldsForXls[this.$t('frc.returnsdate')]= 'createddatetime';
								this.csvFieldsForXls[this.$t('frc.returnstatus')]= 'status';
								this.csvFieldsForXls[this.$t('frc.awbnum')]= 'awbno';
								this.csvFieldsForXls[this.$t('frc.couriercomp')]= 'couriercompany';
								this.csvFieldsForXls[this.$t('frc.suborderid')]= 'suborderid';
								this.csvFieldsForXls[this.$t('frc.clientproductid')]= 'clientproductid';
						        this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
                                this.csvFieldsForXls[this.$t('frc.eanCode')]= 'eancode';
								this.csvFieldsForXls[this.$t('frc.mrp')]= 'mrp';
								this.csvFieldsForXls[this.$t('returnReceiptReport.expectedQuantity')] ='expected_qty';
								this.csvFieldsForXls[this.$t('frc.receivedqty')]= 'received_qty';
				                this.csvFieldsForXls[this.$t('frc.acceptedqty')]= 'accepted_qty';
								this.csvFieldsForXls[this.$t('frc.rejectedqty')]= 'rejected_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.shortQuantity')] ='short_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.extraQuantity')] = 'extra_qty';
								this.csvFieldsForXls[this.$t('returnReceiptReport.excessQuantity')] = 'excess_qty';
								this.csvFieldsForXls[this.$t('frc.rackinaccqty')]= 'accepted_putaway_qty';
								this.csvFieldsForXls[this.$t('frc.rackinrejqty')]= 'rejected_putaway_qty';
								this.csvFieldsForXls[this.$t('frc.createdby')]= 'createdby';
								this.csvFieldsForXls[this.$t('frc.closedby')]= 'closedby';
								this.csvFieldsForXls[this.$t('frc.closeddatetime')]= 'closeddatetime';

                          	this.listReportDataforxls = result.data.data;
							//console.log(result.data.data);

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getFRCRejectList(csvCheck = 0){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frctodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid":  Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"fromdate": fromdate,
				"todate": todate,
				"suborderid":this.SubOrderId,
				"awbno":this.frcawbNo,
				"eancode":this.frceancode,
				"offset": (this.currentPage - 1) * 10,
				"limit": this.pageLimit,
			});
			
				var select_api = 'getFRCRejectReport'
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + select_api,
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
						this.listFRCReportData = result.data.data;
						this.totalRows = Number(result.data.count);
						if (Number(this.totalRows) > Number(this.recordLimit)) {
							this.limitExeed = true
						}
						if (this.totalRows == undefined) {
							this.totalRows = 0;
						}
						if (this.totalRows < this.pageLimit) {
							this.totalPage = 1;
						} else {
							this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
						}
					
					this.isLoading = false;
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getFRCRejectListCSV(){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frcTodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid":  Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"suborderid":this.SubOrderId,
				"awbno":this.frcawbNo,
				"fromdate": fromdate,
				"todate": todate,
				"eancode":this.frceancode,
				"userid":this.userid
			});
			
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + "getFRCRejectReportCSV",
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
							
									this.csvFields = {
										'productid': this.$t('common.productId'),
										'awbno': this.$t('frc.awbnum'),
										'suborderid': this.$t('frc.suborderid'),
										'clientproductid': this.$t('frc.clientproductid'),
										'eancode': this.$t('frc.eanCode'),
										'quantity': this.$t('common.quantity'),
										'rejectreason': this.$t('frc.rejectreason'),
			                          };
								let dateFilter = [];
								skipFilter = ['full_count','id'];
								this.listFRCReportDataCsv = result.data.data
								csvHelper.data.jsonToCSV(this.$t('frc.frcrejectreport'), this.listFRCReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);			
							
								
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					
				}, error => {
					console.error(error)
					this.isLoading = false;
				});

		},
		getFRCRejectListXLS() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;

				return false;
			}
			
			if (this.frcfromDateFlt == '' || this.frcfromDateFlt == null) {
				this.frcFromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.frctoDateFlt == '' || this.frctoDateFlt == null) {
				this.frcTodateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}

			var fromdate = '';
			var todate = '';
			var fromdateship = '';
			var todateship = '';
			var dataFilter = {};
			if (this.frcfromDateFlt != null && this.frcfromDateFlt != "") {
				fromdate = this.dateFormat1(this.frcfromDateFlt);
			}
			if (this.frctoDateFlt != null && this.frctoDateFlt != "") {
				todate = this.dateFormat2(this.frctoDateFlt);
			}
			var months;
			var fromDate = new Date(this.frcfromDateFlt);
			var ToDate = new Date(this.frctoDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if (this.frcfromDateFlt != '' && this.frcfromDateFlt != null && this.frctoDateFlt != null && this.toDateFlt != '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listFRCReportData = [];
				return false;
			}

			this.isLoading = true;
			
			this.input = ({
				"clientid":  Number(this.client),
				"warehouseid":  Number(localStorage.getItem("selectedWarehouse")),
				"fromdate": fromdate,
				"todate": todate,
				"suborderid":this.SubOrderId,
				"awbno":this.frcawbNo,
				"eancode":this.frceancode,
				"userid":this.userid
			});
			
			
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + "getFRCRejectReportCSV",
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.isLoading = false;
					
						if (result.data.count < this.recordLimit) {
							this.listReportDataforxls = [];
							var skipFilter = [];
								this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
								this.csvFieldsForXls[this.$t('frc.awbnum')]= 'awbno';
								this.csvFieldsForXls[this.$t('frc.suborderid')]= 'suborderid';
								this.csvFieldsForXls[this.$t('frc.clientproductid')]= 'clientproductid';
						        this.csvFieldsForXls[this.$t('common.productId')]= 'productid';
                                this.csvFieldsForXls[this.$t('frc.eanCode')]= 'eancode';
								this.csvFieldsForXls[this.$t('common.quantity')] = 'quantity';
								this.csvFieldsForXls[this.$t('frc.rejectreason')] = 'rejectreason';
				               
                          	    this.listReportDataforxls = result.data.data;			

							// this.jsonToCSV('order', this.listOrderReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							 this.$alertify.success(this.$t('common.reportSizeError'));
						}
					
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/returnsreceiptreport/returnsreceiptreport.component.js